import {
  CurrencyValue,
  LineChart,
  formatNumber,
  formatCurrency,
  BarChart
} from '@blockanalitica/ui';
import {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { useChartFillDatasetsDates } from '@/hooks';
import { useCallback } from 'react';
import { useTheme } from 'styled-components';

export default function HistoricGraphs({
  data,
  activeDisplayOption,
  chartDaysAgo
}: {
  data: SimpleChartData[];
  activeDisplayOption: string;
  chartDaysAgo: string;
}) {
  const theme = useTheme();
  const yScaleValueFormatter = useCallback(
    (value: string | number) => {
      switch (activeDisplayOption) {
        case 'total_bad_debt_wallets':
          return `${formatNumber(Number(value))}`;
        default:
          return formatCurrency(Number(value), { maximumFractionDigits: 2 });
      }
    },
    [activeDisplayOption]
  );

  const valueFormatter = useCallback(
    (value: string | number) => {
      switch (activeDisplayOption) {
        case 'total_bad_debt_wallets':
          return (
            <CurrencyValue
              value={value}
              variant="dynamic"
              options={{ notation: 'standard' }}
            />
          );
        default:
          return (
            <CurrencyValue
              value={value}
              variant="dynamic"
              options={{
                notation: 'standard',
                currency: 'USD'
              }}
            />
          );
      }
    },
    [activeDisplayOption]
  );
  const datasets: SimpleChartDataset[] =
    activeDisplayOption === 'total_bad_debt_wallets'
      ? [
          {
            xField: 'date',
            yField: activeDisplayOption,
            backgroundColor: theme.colors.primary
          }
        ]
      : [
          {
            xField: 'date',
            yField: activeDisplayOption
          }
        ];
  const chartData = useChartFillDatasetsDates(data, datasets, chartDaysAgo);

  return activeDisplayOption === 'total_bad_debt_wallets' ? (
    <BarChart
      key={activeDisplayOption}
      data={chartData}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      daysAgo={chartDaysAgo}
    />
  ) : (
    <LineChart
      key={activeDisplayOption}
      data={chartData}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      daysAgo={chartDaysAgo}
    />
  );
}
